import { FC, HTMLAttributes } from "react";
import { useStyles } from "./GameSuggestionCard.style";
import { Typography, TypographyVariant } from "@onmo/ui";
import { ContinuePlay } from "../ContinuePlay";
import { useFetchGames } from "../../../hooks/useFetchGames";
import { useTranslation } from "react-i18next";

interface GameSuggestionCardProps {
  onCloseEndscreen: () => void;
}

export const GameSuggestionCard: FC<
  GameSuggestionCardProps & HTMLAttributes<HTMLDivElement>
> = ({ onCloseEndscreen }) => {
  const classes = useStyles();
  const { getListGameByCategory } = useFetchGames();
  const { t } = useTranslation();

  return (
    <div className={classes.gameSuggestionCard}>
      <Typography
        className={classes.title}
        variant={TypographyVariant.BodyB5Bold}
      >
        {t("people_also_play_heading")}
      </Typography>
      <ContinuePlay
        games={getListGameByCategory("Top 10")}
        isEndscreen
        onCloseEndscreen={onCloseEndscreen}
      />
    </div>
  );
};

export default GameSuggestionCard;
